import { makeStyles } from '@material-ui/core';

import { useCustomTheme } from '@/hooks/useCustomTheme';

export const useParticipantSourceStyles = ({ disabled, loading }: { disabled: boolean; loading: boolean }) => {
  const { palette, customBorderRadius } = useCustomTheme();

  const styleDefinition = {
    root: {
      '& .MuiFilledInput-underline:before': {
        content: 'none',
      },
      '& .MuiFilledInput-underline.Mui-focused:after': {
        content: 'none',
      },
      '& .MuiFilledInput-input': {
        padding: '10px 12px',
        minHeight: '36px',
      },
      '& .MuiTypography-root': {
        overflow: 'hidden',
        maxWidth: '160px',
        textOverflow: 'ellipsis',
      },

      '& .MuiSelect-root': {
        background: disabled || loading ? palette.grey[100] : palette.grey[50],
        borderRadius: customBorderRadius.paper,
        width: '-webkit-fill-available',
      },
      '& .MuiFilledInput-root': {
        height: '56px',
        borderRadius: customBorderRadius.paper,
      },
      '& .MuiSelect-icon': {
        color: disabled || loading ? palette.grey[200] : palette.text.primary,
      },
    },
  };
  const useStyles = makeStyles(styleDefinition);

  const classes = useStyles();

  return { classes };
};
